module.exports = __webpack_public_path__ + "static/img/book43.419ea5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book43.jpg
// module id = lA1h
// module chunks = 1